import './index.scss';

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";


window.addEventListener('load', function(){

  if(document.querySelector('.hero-type-home') || document.querySelector('.hero-type-contact')){

    const heroTl = gsap.timeline()

    heroTl
      .to(".pd_splide", {opacity: 1, duration: 2})
      .from(".pd_hero-image", {opacity: 0, duration: 2}, ">-2" )
      .from(".pd-block-hero .acf-innerblocks-container > *", {
        opacity: 0,
        y: 20,
        duration: 0.5,
        stagger: { // wrap advanced options in an object
          each: 0.3,
          ease: "linear", 
        }
      }, '>-1.5')
      .from(".pd_hero-contact-footer-info", { opacity: 0,
        y: 20,
        duration: 0.5,}, '>-0.25')

  }


  if(document.querySelector('.hero-type-home')){
    const scrollTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.hero-type-home',
        toggleActions: "restart none none reverse",
        pin: false,   // pin the trigger element while active
        start: "bottom 80%", // when the top of the trigger hits the top of the viewport
      },
    });
  
    scrollTl
      .to('.scroll-indicator', {opacity: 0, duration: 1})

    const handleScroll = (e) => {
      e.preventDefault()
      window.scrollTo({top: window.innerHeight, left:0});
    }
  
    const scrollBtn = document.getElementById('pd_hero-scroll')
  
    scrollBtn.addEventListener('click', handleScroll)
  }

})